export default __webpack_public_path__ + "static/media/object--fire-hydrant.d91d17bd.png";